import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Container, Row } from 'reactstrap';

import SimpleHeader from '../../../components/Headers/SimpleHeader';
import Loader from 'components/Loader';
import ProtocolList from './components/ProtocolList';
import { useRecordTypesByUser } from '../../RecordType/hooks/useRecordTypesByUser';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import {
  POSSIBLE_FILTERS_ENTITIES,
  useMemorizeFilters
} from '../../../hooks/useMemorizeInputsFilters';

function ProtocolListIndex() {
  const [selectedRecordType, setSelectedRecordType] = useState();
  const { recordTypes, isLoadingRecordTypes, getRecordTypesByUser } =
    useRecordTypesByUser(entitiesName.PROTOCOL);
  const [hasChangedRecordType, setHasChangedRecordType] = useState(false);
  const { getMemorizedFilters } = useMemorizeFilters(
    POSSIBLE_FILTERS_ENTITIES.PROTOCOL
  );
  const [isPageReloaded, setIsPageReloaded] = useState(false);
  const [isListenerOnRecordType, setIsListenerOnRecordType] = useState(false);

  useEffect(() => {
    getRecordTypesByUser();
  }, [getRecordTypesByUser]);

  useEffect(() => {
    if (recordTypes && recordTypes.length > 0) {
      const filters = getMemorizedFilters();
      const selectedRecordType = filters?.selectedRecordType?.value;
      const filteredRecordTypes = recordTypes.filter(
        (recordType) => recordType.id === selectedRecordType
      );

      if (selectedRecordType && filteredRecordTypes.length > 0) {
        setSelectedRecordType(filteredRecordTypes[0]);
      } else {
        setSelectedRecordType({
          label: recordTypes[0]?.name,
          value: recordTypes[0]?.id
        });
      }
    }
  }, [getMemorizedFilters, recordTypes]);

  const handleSelectedRecordTypeChange = (data, { isReloadPage = false }) => {
    setIsListenerOnRecordType(true);
    if (isReloadPage) {
      setIsPageReloaded(true);
    } else {
      setIsPageReloaded(false);
    }

    if (!data) {
      setSelectedRecordType(null);
      setHasChangedRecordType(false);
    }
    setSelectedRecordType(data);
    setHasChangedRecordType(true);
  };

  const renderWithBaseLayout = (children) => {
    return (
      <>
        <SimpleHeader
          name="Form validation"
          parentName="Forms"
          showBackArrow="not"
        />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <div className="card-wrapper">
                <Card>
                  <CardHeader>
                    <div className="d-flex flex-row justify-content-between">
                      <h3 className="mb-0">Protocolos</h3>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">{children}</CardBody>
                </Card>
              </div>
            </div>
          </Row>
        </Container>
      </>
    );
  };

  const render = () => {
    if (isLoadingRecordTypes) {
      return renderWithBaseLayout(
        <Row className="justify-content-md-center">
          <Loader />
        </Row>
      );
    }

    if (!isLoadingRecordTypes && !recordTypes?.length) {
      return renderWithBaseLayout(
        <div>
          <span className="small">
            Você não tem acesso a nenhum tipo de protocolo.
          </span>
        </div>
      );
    }

    return (
      <>
        {selectedRecordType && (
          <ProtocolList
            recordTypes={recordTypes}
            selectedRecordType={selectedRecordType}
            handleSelectedRecordTypeChange={handleSelectedRecordTypeChange}
            hasChangedRecordType={hasChangedRecordType}
            setHasChangedRecordType={setHasChangedRecordType}
            isPageReloaded={isPageReloaded}
            isListenerOnRecordType={isListenerOnRecordType}
            setIsListenerOnRecordType={setIsListenerOnRecordType}
          />
        )}
      </>
    );
  };

  return render();
}

export default ProtocolListIndex;
